module.exports = __webpack_public_path__ + "static/media/eight_-monkeys.60610744.png";